import { render, staticRenderFns } from "./consultas.vue?vue&type=template&id=6d7c9e20"
import script from "./consultas.vue?vue&type=script&lang=js"
export * from "./consultas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports